import { Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-back-office24-order-add-additional-services',
  standalone: false,
  templateUrl: './back-office24-order-add-additional-services.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-order-add-additional-services.component.css'
})
export class BackOffice24OrderAddAdditionalServicesComponent implements OnInit {
  @Output() saveChangesEvent = new EventEmitter<void>();

  remainingServices: any[] = [];
  selectedServices: FormArray;
  paymentRequired: FormControl;
  servicesForm: FormGroup;
  componentDestroyed$: Subject<boolean> = new Subject();
  orderId: string;
  orderAdditionalServices: any[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      orderId: string,
      orderAdditionalServices: any[],
      allAdditionalServices: any[]
    },
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<BackOffice24OrderAddAdditionalServicesComponent>,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private backofficeService: BackOfficeService
  ) {
    this.orderId = this.data.orderId;
  }

  ngOnInit(): void {
    this.initForm();
    this.filterRemainingServices();
  }

  initForm(): void {
    this.servicesForm = this.fb.group({
      selectedServices: this.fb.array([]),
      paymentRequired: ['no']
    });
    this.selectedServices = this.servicesForm.get('selectedServices') as FormArray;
    this.paymentRequired = this.servicesForm.get('paymentRequired') as FormControl;
  }

  filterRemainingServices(): void {
    if (!this.data.allAdditionalServices || !this.data.orderAdditionalServices) {
      return;
    }

    const existingServiceNames = new Set(
      this.data.orderAdditionalServices.map(service => service.name)
    );

    this.remainingServices = this.data.allAdditionalServices.filter(
      service => !existingServiceNames.has(service.name)
    );

    this.orderAdditionalServices = this.data.allAdditionalServices.filter(
      service => existingServiceNames.has(service.name)
    );

  }

  onCheckboxChange(event: any, service: any): void {
    if (this.selectedServices.controls.some(x => x.value.id === service.id)) {
      const index = this.selectedServices.controls.findIndex(x => x.value.id === service.id);
      if (index >= 0) {
        this.selectedServices.removeAt(index);
      }
    } else {
      this.selectedServices.push(new FormControl(service));
    }
  }

  submitSelectedServices(): void {
    if (!this.orderId) {
      this.snackBar.open('No order ID found', 'Close', { duration: 3000 });
      return;
    }

    const selectedServiceIds: number[] = this.selectedServices.value.map(service => service.id);

    if (selectedServiceIds.length === 0) {
      this.snackBar.open('No services selected', 'Close', { duration: 3000 });
      return;
    }

    this.dialogRef.close();
    this.backofficeService.addAdditionalServicesToOrder(this.orderId, selectedServiceIds, (this.paymentRequired.value === 'yes' ? true : false))
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        response => {
          this.snackBar.open('Services added successfully', 'Close', { duration: 3000 });
          this.saveChangesEvent.emit();
          this.dialogRef.close();
        },
        error => {
          this.snackBar.open('Error adding services: ' + error.message, 'Close', { duration: 3000 });
        }
      );
  }

  cancelDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    // this.componentDestroyed$.next(true);
    // this.componentDestroyed$.complete();
  }
}
